<template>
    <div class="large-container">
        <p class="order-confirm bold">Confirmación de orden</p>
        <p class="order-summary">Su orden #{{orderSummary.number}} está en proceso</p>
        <img src="../../public/img/CarritoDeCompra.png" alt="">
        <p class="order-gratitude bold">Gracias por su preferencia</p>
        <p class="order-estimation">Se estima que la orden llegará a su dirección el {{orderSummary.upperBoundDelivery | get-date}} entre {{orderSummary.lowerBoundDelivery | get-time}} y {{orderSummary.upperBoundDelivery | get-time}}</p>
        <p class="legend bold">*En productos genéricos, la presentación de los laboratorios pueden variar.</p> 
        <p class="legend bold">*Las imagenes publicadas son meramente ilustrativas y pueden diferir del producto entregado.</p>
        <p class="legend bold">*Por seguridad, no se aceptan cambios ni devoluciones. Le pedimos verificar su orden al recibirla.</p>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    
    computed:{
        ...mapState(['orderSummary'])
    }
   
}
</script>
<style scoped>
    .order-confirm{
        font-size: 1.8rem;
    }
    .order-summary{
        font-size: 1.5rem;
    }

    .order-gratitude{
        font-size: 1.2rem;
    }

    .order-estimation{
        font-size: 1.4rem;
    }
    .legend{
        font-size:.8rem;
    }

</style>
